import { createFileRoute } from '@tanstack/react-router'

import { BrokerPage } from '#/modules/fmcsa/broker-page'

export const Route = createFileRoute('/_shell/brokers/$usdot')({
  component: function BrokerRoute() {
    const { usdot } = Route.useParams()
    return <BrokerPage usdot={usdot} />
  },
})
